export default "__VITE_ASSET__DABTBQao__"